import ViewBase from "../../../../framework/core/mvvm/view_base";
const { ccclass, property } = cc._decorator;

@ccclass
export default class BindInviteCodeView extends ViewBase {
    @property(cc.EditBox)
    inputValue:cc.EditBox = null
}